import { Button } from "@/components/ui/button";

/**
 * The failed-load state of an item editor tab, with a retry.
 * @param message - What failed
 * @param onRetry - Reloads the tab's data
 */
export const ItemTabError = ({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) => (
  <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
    <p className="text-sm text-muted-foreground">{message}</p>
    <Button variant="outline" size="sm" onClick={onRetry}>
      Retry
    </Button>
  </div>
);
